'use client';

import { usePathname } from 'next/navigation';
import { shouldHideHeader } from '@/utils/header.util';
import NavBar from './nav-bar.component';
import NavBarSylndrLogoOnly from './nav-bar-sylndr-logo-only.component';
import { AVAILABLE_LANGUAGES } from '@/constants';

export default function DynamicHeader({ lang }: { lang: AVAILABLE_LANGUAGES }) {
    const pathname = usePathname();
    const isHeaderHidden = shouldHideHeader(pathname);

    return (
        <div className="fixed top-0 left-0 right-0 z-50">
            {isHeaderHidden ? (
                <NavBarSylndrLogoOnly lang={lang} />
            ) : (
                <NavBar lang={lang} />
            )}
        </div>
    );
}
